import serviceInterceptor from '../../services/ServiceInterceptor';

export const checkDwollaTransferStatusAPI = () =>
  serviceInterceptor.get(`/rebates/checkDwollaTransferStatus`);
